<template>
    <div>
        <div class="tabs is-boxed">
            <ul>
                <router-link
                    :to="{ name: 'client-curacao-balance-reports' }"
                    active-class="is-active"
                    tag="li"
                    exact
                >
                    <a>Balance reports</a>
                </router-link>
            </ul>
        </div>

        <router-view />
    </div>
</template>
<script>
export default {
    name: 'client-curacao'
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/curacao/index.vue